import React from 'react'
import LimitedViewText from './LimitedViewText'

import bgHeader from 'images/carousel-2.jpg'
import pdfLogo from 'images/pdf-logo.png'

export default function ContentPillarStrategy1({ limitedView }) {
  const texts = {
    title: 'Content Pillar Strategy',
    description: 'Here is a content pillar strategy you should fill yourself helping you find the topics of conversation and type of stories you should create about your brand and products:',
    box1Title: 'Company / Product News',
    box1Text: 'Notice the lifestyle choice your audience makes and their interest and attitudes towards your industry',
    box1Recommendation: '2 to 3 posts a week.',
    box2Title: 'Brand Purpose',
    box2Text: 'People are more likely to buy the why not the what and so you should talk about your brand purpose or values. This type of content is more about what your brand believes in , and why you do what do you do.',
    box2Recommendation: '1 to 2 posts a week.',
    box3Title: 'Lifestyle',
    box3Text: 'Show your audience you understand them by creating content about their lifestyle and celebrate it, endorse it.Lussy.io has given lots of topics they follow and are interested in, so dig in and find what’s relevant to you and them.',
    box3Recommendation: '2 to 3 posts a week.',
    box4Title: 'Timely',
    box4Text: 'Don’t stress too much about it but open your eyes to what your audience is exposed to on day to day basis, what the trending topics are and check if your brand can ride on a topic or trending post. Have an opinion about it.',
    box4Recommendation: 'When relevant',
    recommendation: 'Recommendation',
  }

  return (
    <section className="section md-pt4 sm-p0" data-anchor="content-pillar-strategy-1">
      <div className="slider-box slider-box--pdf-p0 bg-white box-shadow-box p4 x-lg-p3">
        <div>
          <div className="flex mb2 pt3 sm-p0">
            <div className="border border-violet-red bw-2 mr2 rounded-6" style={{ height: 20, width: 20 }} />
            <div className="border border-violet-red bw-2 mr2 rounded-6" style={{ height: 20, width: 20 }} />
            <div className="bg-violet-red mr2 rounded-6" style={{ height: 20, width: 20 }} />
            <div className="border border-violet-red bw-2 mr2 rounded-6" style={{ height: 20, width: 20 }} />
          </div>

          <h2 className="persona-sub-title mb3">{texts.title}</h2>

          <p className="fs-18 mb4">{texts.description}</p>

          <div className="flex flex-wrap mxn1">
            <div className="col-3 flex px1 sm-col-12 sm-mb3">
              <div className="border border-violet-red bw-2 box-shadow col-12 flex flex-column p2 rounded-6">
                {limitedView ?
                  <LimitedViewText />
                  : <>
                    <div className="flex-auto">
                      <p
                        className="bg-violet-red bold circle flex flex-center flex-justify-center mb2 text-white"
                        style={{ height: 40, width: 40 }}
                      >
                        1
                      </p>

                      <p className="h3 mb2">{texts.box1Title}</p>

                      <p className="h5 mb3">{texts.box1Text}</p>
                    </div>

                    <p className="h5"><span className="text-violet-red">{texts.recommendation}</span>:<br /> {texts.box1Recommendation}</p>
                  </>
                }
              </div>
            </div>

            <div className="col-3 flex px1 sm-col-12 sm-mb3">
              <div className="border border-violet-red bw-2 box-shadow col-12 flex flex-column p2 rounded-6">
                {limitedView ?
                  <LimitedViewText />
                  : <>
                    <div className="flex-auto">
                      <p
                        className="bg-violet-red bold circle flex flex-center flex-justify-center mb2 text-white"
                        style={{ height: 40, width: 40 }}
                      >
                        2
                      </p>

                      <p className="h3 mb2">{texts.box2Title}</p>

                      <p className="h5 mb3">{texts.box2Text}</p>
                    </div>

                    <p className="h5"><span className="text-violet-red">{texts.recommendation}</span>:<br /> {texts.box2Recommendation}</p>
                  </>
                }
              </div>
            </div>

            <div className="col-3 flex px1 sm-col-12 sm-mb3">
              <div className="border border-violet-red bw-2 box-shadow col-12 flex flex-column p2 rounded-6">
                {limitedView ?
                  <LimitedViewText />
                  : <>
                    <div className="flex-auto">
                      <p
                        className="bg-violet-red bold circle flex flex-center flex-justify-center mb2 text-white"
                        style={{ height: 40, width: 40 }}
                      >
                        3
                      </p>

                      <p className="h3 mb2">{texts.box3Title}</p>

                      <p className="h5 mb3">{texts.box3Text}</p>
                    </div>

                    <p className="h5"><span className="text-violet-red">{texts.recommendation}</span>:<br /> {texts.box3Recommendation}</p>
                  </>
                }
              </div>
            </div>

            <div className="col-3 flex px1 sm-col-12">
              <div className="border border-violet-red bw-2 box-shadow col-12 flex flex-column p2 rounded-6">
                {limitedView ?
                  <LimitedViewText />
                  : <>
                    <div className="flex-auto">
                      <p
                        className="bg-violet-red bold circle flex flex-center flex-justify-center mb2 text-white"
                        style={{ height: 40, width: 40 }}
                      >
                        4
                      </p>

                      <p className="h3 mb2">{texts.box4Title}</p>

                      <p className="h5 mb3">{texts.box4Text}</p>
                    </div>

                    <p className="h5"><span className="text-violet-red">{texts.recommendation}</span>:<br /> {texts.box4Recommendation}</p>
                  </>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
